export const featureXero = 174973096601;
export const featureCustomDimension = 175022618301;
export const featurePubmatic = 177483407401;
export const featureSeedooh = 177624345901;
export const featureEmerald = 177580250301;

export enum xeroEvents {
    Connecting = 175005784502,
    SelectTenants = 175005786701,
    Connected = 175005789301,
}

export enum customDimensionEvents {
    Create = 175022627701,
    Edit = 175022634002,
    Archive = 175022643301,
    Clone = 175022650101
}

export enum EmeraldEvents {
    ToggleOn = 177580253901,
    SentMessage = 177580255201,
    ToggleOff = 177580256901,
}

export const featureScope3 = 175264712501;

export const featureGoogleSso = 177198029503;

export const featureEntraSso = 177198037308;